(function () {
  'use strict';

  const params = new URLSearchParams(window.location.search);
  const pin = params.get('pin');
  if (!pin) return;

  const HANDLE_RE = /^[a-z0-9](?:[a-z0-9-]{0,254})$/i;
  const MAX_PINS = 10;

  // Parse comma-separated handles: trim, validate, dedupe, cap.
  const handles = [];
  pin.split(',').forEach(function (raw) {
    const h = raw.trim();
    if (!h || handles.length >= MAX_PINS) return;
    if (!HANDLE_RE.test(h)) return;
    if (handles.indexOf(h) === -1) handles.push(h);
  });
  if (!handles.length) return;

  function dedupe(grid, handle) {
    const matches = grid.querySelectorAll(
      'li[data-product-handle="' + handle + '"]:not([data-pinned])'
    );
    if (!matches.length) return null;
    for (let i = 1; i < matches.length; i++) matches[i].remove();
    return matches[0];
  }

  function place(grid, anchor, el) {
    el.setAttribute('data-pinned', 'true');
    grid.replaceChild(el, anchor);
  }

  function resolve(grid, handle, anchor) {
    const existing = dedupe(grid, handle);
    if (existing) {
      place(grid, anchor, existing);
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '?view=card', {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) { anchor.remove(); return; }
        const raced = dedupe(grid, handle);
        if (raced) {
          place(grid, anchor, raced);
          return;
        }
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const card = tmp.querySelector('li.product-card, li[data-product-handle]');
        if (!card) { anchor.remove(); return; }
        place(grid, anchor, card);
      })
      .catch(function () { anchor.remove(); });
  }

  function init() {
    const grid = document.getElementById('collection');
    if (!grid) return;
    const key = handles.join(',');
    if (grid.dataset.pinInit === key) return;
    grid.dataset.pinInit = key;

    // Reserve an ordered slot per handle at the front. Each async resolve
    // fills its own slot, so arrival order can't scramble the pin order.
    const first = grid.firstElementChild;
    handles.forEach(function (handle) {
      const anchor = document.createElement('li');
      anchor.setAttribute('data-pin-anchor', '');
      anchor.style.display = 'none';
      grid.insertBefore(anchor, first);
      resolve(grid, handle, anchor);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Filter fetches swap out the whole grid (incl. the silent in-stock
  // auto-apply on page load), discarding placed pins. The swapped grid is a
  // fresh element, so the pinInit guard allows a re-run. Only re-pin while
  // the pin param is still in the URL: user-applied filters push a new URL
  // without it, and pins should not survive that (pre-existing behavior).
  window.addEventListener('initFilters', function () {
    if (new URLSearchParams(window.location.search).get('pin') === pin) init();
  });
})();
